class BlockBuilderQtySelector extends HTMLElement {
  constructor() {
    super();
    this.qtyInput = this.querySelector('input');
    this.minusButton = this.querySelector('button[name="minus"]');
    this.plusButton = this.querySelector('button[name="plus"]');
    this.variantAvailable = this.dataset.variantAvailable === 'true';

    this.minusButton.addEventListener('click', this.onMinusButtonClick.bind(this));
    this.plusButton.addEventListener('click', this.onPlusButtonClick.bind(this));
  }

  slotCollection = null;

  connectedCallback() {
    this.variantId = parseInt(this.qtyInput.dataset.quantityVariantId);
    this.productId = parseInt(this.qtyInput.dataset.productId);
    this.slotCollection = this.qtyInput.dataset.slotCollection;
    this.handle = this.qtyInput.dataset.handle;
  }

  onMinusButtonClick(event) {
    event.preventDefault();
    if (parseInt(this.qtyInput.value) > 0) {
      this.qtyInput.value = parseInt(this.qtyInput.value) - 1;
      this.onQtyInputChange('minus');
    }
  }

  onPlusButtonClick(event) {
    event.preventDefault();
    this.qtyInput.value = parseInt(this.qtyInput.value) + 1;
    this.onQtyInputChange('plus');
  }

  onQtyInputChange(type = 'plus') {
    this.updateMinusButtonState();
    this.dispatchEvent(new CustomEvent('bb-knife-qty-changed', {
      detail: {
        productId: this.productId,
        variantId: this.variantId,
        quantity: this.qtyInput.value,
        handle: this.handle,
        price: Number(this.qtyInput.dataset.price),
        slotCollection: this.slotCollection,
        type: type,
      }
    }));

    const productLabel = this.dataset.productLabel || '';
    const statusMessage = window.accessibilityStrings?.quantityUpdated
      ?.replace('[quantity]', this.qtyInput.value)
      ?.replace('[product]', productLabel);

    if (statusMessage && typeof window.announceStatus === 'function') {
      window.announceStatus(statusMessage);
    }
  }

  updateMinusButtonState() {
    if (parseInt(this.qtyInput.value) > 0 && this.variantAvailable) {
      this.minusButton.disabled = false;
    } else {
      this.minusButton.disabled = true;
    }
  }

  updatePlusButtonState(shouldDisable) {
    if (this.variantAvailable) {
      this.plusButton.disabled = shouldDisable;
    }
  }
}

customElements.define('block-builder-qty-selector', BlockBuilderQtySelector);